<template>
    <section
        class="w-screen sm:h-[58px] h-[77px] border bg-h-primary-50 flex items-center mx-auto min-h-full overflow-x-visible custom-breadcrumb-options">
        <Breadcrumb :home="home" :model="items"
            class="w-screen !pl-[3vw] !text-base !leading-5 custom-breadcrumb !text-neutral-900">
            <template #item="{ item }">
                <span @click="item?.command" :class="`${item?.command
                    ? 'cursor-pointer hover:text-h-secondary-700 transition-all font-bold'
                    : 'cursor-default'
                    } capitalize break-all line-clamp-1 max-w-[900px]`">
                    {{ item.label }}
                </span>
            </template>
        </Breadcrumb>
    </section>
</template>

<script lang="ts">
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent, PropType } from "vue";
export default defineComponent({
    name: "breadcrumbForum",
    data() {
        return {
            home: {
                label: this.$t("labels.generic", { pt: "Lista de fóruns", en: "List of forums" }),
                command: () => this.backToListForumView(),
            },
            items: [{}],
            endOptions: { 
                editTopic: { label: this.$t("labels.generic", { pt: "Editar Tópico", en: "Edit Topic" }) }, 
                addTopic: { label: this.$t("labels.generic", { pt: "Adicionar Tópico", en: "Add Topic" }) },
                editComment: { label: this.$t("labels.generic", { pt: "Editar Comentário", en: "Edit Comment"})}
            },
            params: {
                courseName: this.$route.params.courseName as string,
                id: this.$route.params.id as string,
            },
        }
    },
    mounted() {
        this.setItemsBreadCrumb();
    },
    methods: {
        formatText(text: string): string {
            const replace = text.replaceAll("-", " ");
            return replace;
        },
        setItemsBreadCrumb(): void {
            this.items[0] = { label: this.formatText(this.$route.params.courseName as string), command: () => this.backToForumView() }
            this.setEndOptions();
        },
        setEndOptions(): void {
            const routeName = this.$route.name;
            if (routeName && this.endOptions[routeName]) this.items.push(this.endOptions[routeName])
        },
        backToForumView(): void {
            this.go.redirectToPage("forum", this.params);
        },
        backToListForumView(): void {
            this.go.redirectToPage("listForums")
        }
    },
    computed: {
        go(): GoToRoute {
            return new GoToRoute();
        },
    },
});
</script>